import { Checkbox } from '@heroui/react';
import { ColumnDef } from '@tanstack/react-table';
import React from 'react';

import { DeviceData } from '../../../../types';
import { TranslationStatusRow } from '../../../../utils';
import { ActionRow } from './Rows/ActionRow';
import { ColorRow } from './Rows/ColorRow';

interface DeviceColumnsProps {
  selectedIds: string[];
  onToggleRow: (id: string) => void;
  onToggleAll: () => void;
  areAllSelected: boolean;
  isSomeSelected: boolean;
  onDelete: (device: DeviceData) => void;
  isDeleting: boolean;
}

export const getDeviceColumns = ({
  selectedIds,
  onToggleRow,
  onToggleAll,
  areAllSelected,
  isSomeSelected,
  onDelete,
  isDeleting,
}: DeviceColumnsProps): ColumnDef<DeviceData>[] => [
  {
    id: 'select',
    header: () => (
      <Checkbox
        size="sm"
        aria-label="Select all devices on this page"
        isSelected={areAllSelected}
        isIndeterminate={!areAllSelected && isSomeSelected}
        onValueChange={onToggleAll}
      />
    ),
    meta: { width: 'w-12' },
    enableSorting: false,
    cell: ({ row }) => (
      <Checkbox
        size="sm"
        aria-label={`Select ${row.original.name ?? row.original.id}`}
        isSelected={selectedIds.includes(row.original.id)}
        onValueChange={() => onToggleRow(row.original.id)}
      />
    ),
  },
  {
    accessorKey: 'name',
    header: 'Name',
  },
  {
    header: 'Serial no.',
    accessorKey: 'serialNumber',
  },
  {
    header: 'Size',
    accessorKey: 'size',
  },
  {
    header: 'Color',
    accessorKey: 'color',
    enableSorting: false,
    cell: ({ row }) => <ColorRow data={row.original} />,
  },
  {
    header: 'Created At',
    accessorKey: 'createdAt',
    cell: ({ row }) => row.original.createdAt ?? '—',
  },
  {
    header: 'Translation Status',
    id: 'translationStatus',
    enableSorting: false,
    cell: ({ row }) => (
      <TranslationStatusRow
        value={(row.original.translationStatus ?? 'error') as 'success' | 'pending' | 'error'}
      />
    ),
  },
  {
    header: '',
    id: 'actions',
    enableSorting: false,
    meta: { align: 'right' },
    cell: ({ row }) => (
      <ActionRow
        data={row.original}
        onDelete={onDelete}
        isDeleting={isDeleting}
      />
    ),
  },
];
